<template>
  <draggable
      class="list-group"
      v-model="list"
      v-bind="dragOptions"
      :move="onMove"
      @start="isDragging=true"
      @end="isDragging=false"
  >
    <transition-group type="transition" :name="'flip-list'" >
      <v-list
          class="list-group-item"
          v-for="element in list"
          :key="element.order"
          color="transparent"
      >
        <v-list-item>
          <v-card
              elevation="5"
              width="100%"
              class="rounded-xl mb-3 pp-relative pr-5"
          >
            <v-icon
                class="drag-btn center"
                color="primary">
              mdi-drag
            </v-icon>

            <v-icon
                class="right-close-btn ml-5 right"
                color="primary"
                @click="remove(element)"
            >
              mdi-close
            </v-icon>

            <slot
                v-if="element.item.type == 'video'"
                name="video"
                v-bind:video="element.item.data"
            ></slot>
            <slot v-if="element.item.type == 'scorm'" name="scorm" v-bind:scorm="element.item.data"></slot>
          </v-card>
        </v-list-item>
      </v-list>
    </transition-group>
  </draggable>
</template>

<script>

import draggable from 'vuedraggable';

export default {
  name: "Sortable",
  components: {
    draggable,
  },
  data() {
    return {
      isDragging: false,
      delayedDragging: false,
    };
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
          (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    remove(item) {
      const newItems = this.items;
      const index = this.items.indexOf(item.item);
      if(index >= 0) {
        newItems.splice(index, 1);
      }
      this.reorder(newItems);
    },
  },
  computed: {
    list: {
      get() {
        return this.items.map((item, index) => {
          return { item, order: index + 1, fixed: false };
        });
      },
      set(newOrder) {
        const formattedResources = [];
        newOrder.forEach(function(resource) {
          formattedResources.push(Object.assign({}, resource.item));
        });
        this.reorder(formattedResources);
      },
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
  props: {
    reorder: {
      type: Function,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}

.pp-relative {
  position: relative;
}

.drag-btn {
  position: absolute !important;
  left: 20px;
  z-index: 1000;
  margin-top: auto;
}
</style>